<h1 matDialogTitle>{{ title }}</h1>
<div mat-dialog-content class="space-y-4" [innerHTML]="confirmMessage | marked"></div>
<div mat-dialog-actions class="pt-24 space-x-2 space-y-2">
    <button mat-raised-button class="mat-accent" (click)="dialogRef.close(true)">{{ yesButton }}</button>
    <button mat-button (click)="dialogRef.close(false)">{{ noButton }}</button>
</div>
